// Table of contents:
// 1 supplierInformation
import { Supplier } from '../../../data'
import { getTranslationsForConfig } from '../getTranslationsForConfig'

export const createSupplier = (): Supplier => {
  return {
    // 1 supplierInformation
    supplierInformation: {
      id: {
        enabled: true,
        label: getTranslationsForConfig(
          'supplier.supplierInformation.form.id.label',
        ), // t('supplier.supplierInformation.form.id.label')
        placeholder: getTranslationsForConfig(
          'supplier.supplierInformation.form.id.placeholder',
        ), // t('supplier.supplierInformation.form.id.placeholder')
        readonly: false,
        validation: {
          isRequired: true,
          regex: '^[0123456789]{10}$',
          regexErrorMessage: getTranslationsForConfig(
            'supplier.supplierInformation.form.id.errors.regex',
          ), // t('supplier.supplierInformation.form.id.errors.regex')
        },
      },
    },
  }
}
